/**
 * Enumeration of the possible progress states
 */ export var ProgressState = /*#__PURE__*/ function(ProgressState) {
    /**
     * Not started state
     */ ProgressState["NotStarted"] = "NotStarted";
    /**
     * In progress state
     */ ProgressState["InProgress"] = "InProgress";
    /**
     * Complete state
     */ ProgressState["Complete"] = "Complete";
    return ProgressState;
}({});
